'use client';
import React from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { Home, Plane, CreditCard, Hotel, User, BookOpen } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const MOBILE_NAV_ITEMS = [
  { key: 'mob-home', label: 'Home', href: '/', icon: Home },
  { key: 'mob-hotels', label: 'Hotels', href: '/hotel-detail', icon: Hotel },
  { key: 'mob-flights', label: 'Flights', href: '/flights', icon: Plane },
  { key: 'mob-blog', label: 'Blog', href: '/blog', icon: BookOpen },
  { key: 'mob-payment', label: 'Payment', href: '/payment', icon: CreditCard },
  { key: 'mob-signin', label: 'Sign In', href: '/sign-up-login-screen', icon: User },
];

interface MobileMenuProps {
  onClose: () => void;
}

export default function MobileMenu({ onClose }: MobileMenuProps) {
  const router = useRouter();
  const pathname = usePathname();

  const isActive = (href: string) => {
    if (href === '/') return pathname === '/';
    return pathname?.startsWith(href);
  };

  return (
    <div className="lg:hidden border-t border-gray-100 dark:border-gray-800 py-2 animate-slide-up">
      <div className="grid grid-cols-3 gap-1 p-2">
        {MOBILE_NAV_ITEMS?.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          return (
            <button
              key={item?.key}
              onClick={() => {
                router?.push(item?.href);
                onClose();
              }}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-col items-center gap-1.5 px-3 py-3 rounded-xl text-xs font-display font-500 transition-all duration-150 active:scale-95 ${
                active
                  ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400' :'text-gray-700 dark:text-gray-300 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:text-primary-600 dark:hover:text-primary-400'
              }`}
              style={{ fontWeight: active ? 600 : 500 }}
            >
              <Icon size={20} className={active ? 'text-primary-500' : 'text-primary-400'} />
              {item?.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
